import './index.scss'
import '../../assets/scripts/number.js'
import Swiper from 'swiper/swiper-bundle.min.js'
var swiper = new Swiper(".mySwiper", {
  slidesPerView: 5,
  spaceBetween: 30,
  loop:true,
  observer: true,//修改swiper自己或子元素时，自动初始化swiper
  observeParents: true,//修改swiper的父元素时，自动初始化swiper
  speed:4000,//匀速时间
    autoplay: {
        delay: 0,
        stopOnLastSlide: false,
        disableOnInteraction: false,
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 5,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        spaceBetween: 10,
      }
    } 
});  
// 数字滚动
var istrue = true;
var s = $(window).scrollTop();
if (s > $(".banner").offset().top + $("header").height() * 3  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
$(window).on("scroll",
function() {
   var s = $(window).scrollTop();
    if (s >$(".banner").offset().top + $("header").height() * 3  && istrue) {
        $(".timer").each(count);
        function count(a) {
            var b = $(this);
            a = $.extend({},
            a || {},
            b.data("countToOptions") || {});
            b.countTo(a)
        };
        istrue = false;
    };
})

$(".section5 ul li").eq(0).addClass("active");
$(".section5 .pic img").eq(0).addClass("active");
$(".section5 ul li").click(function() {
    let index = $(this).index();
    $(this).addClass("active").siblings().removeClass("active");
    $(".section5 .pic img").eq(index).addClass("active").siblings().removeClass("active");
})